export function splitName(name: string) {
  const split = name.split(" ");

  if (split.length > 1) {
    const firstName = split.slice(0, split.length - 1).join(" ");
    const lastName = split[split.length - 1];

    return {
      firstName: firstName,
      lastName: lastName
    };
  }

  return { firstName: split[0], lastName: "" };
}
